import { useState } from 'react';

export default function CollaboratorAvatars({ participants }) {
  const [showTooltip, setShowTooltip] = useState(null);
  
  if (!participants || participants.length === 0) return null;

  // Show max 4 avatars, then +N
  const visible = participants.slice(0, 4);
  const overflow = participants.length - 4;

  return (
    <div className="flex items-center">
      {/* Stacked avatars */}
      <div className="flex -space-x-2">
        {visible.map((p, idx) => (
          <div
            key={p.session_id}
            className="relative"
            onMouseEnter={() => setShowTooltip(p.session_id)}
            onMouseLeave={() => setShowTooltip(null)}
          >
            {/* Avatar circle */}
            <div
              className="w-8 h-8 rounded-full border-2 border-white flex items-center justify-center text-xs font-medium text-white shadow-sm cursor-default transition-transform hover:scale-110 hover:z-10"
              style={{ 
                backgroundColor: p.cursor_color,
                zIndex: visible.length - idx
              }}
            >
              {p.username?.charAt(0).toUpperCase() || '?'}
            </div>

            {/* Owner indicator */}
            {p.is_owner && (
              <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-yellow-400 rounded-full border border-white flex items-center justify-center">
                <span className="text-[8px]">★</span>
              </div>
            )}

            {/* Tooltip */}
            {showTooltip === p.session_id && (
              <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 px-2 py-1 bg-gray-900 text-white text-xs rounded whitespace-nowrap z-50">
                {p.username} {p.is_owner ? '(Owner)' : ''}
                <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-gray-900 rotate-45" />
              </div>
            )}
          </div>
        ))}

        {/* Overflow indicator */}
        {overflow > 0 && (
          <div className="w-8 h-8 rounded-full border-2 border-white bg-gray-200 flex items-center justify-center text-xs font-medium text-gray-600 shadow-sm">
            +{overflow}
          </div>
        )}
      </div>

      {/* Live indicator */}
      <div className="ml-3 flex items-center gap-1.5">
        <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
        <span className="text-xs text-gray-500 font-medium">
          {participants.length} {participants.length === 1 ? 'person' : 'people'}
        </span>
      </div>
    </div>
  );
}
